/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// @mui
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Autocomplete } from '@mui/material';

// components
import Iconify from '../../../components/iconify';

import API from '../../../api';

export default function DivisionUpdate({ division, resetAll, divisionUsers }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [order, setOrder] = useState(0);

  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    setName(division.d_name);
    setOrder(division.order_n);
    // console.log(divisionUsers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [division]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await API.put(`/division`, {
        d_id: division.d_id,
        d_name: name,
        order_n: order,
        a_id: selectedUser?.a_id,
      });
      const {
        data: { success, message },
      } = response;
      if (success === 1) {
        resetAll();
        handleClose();
        toast.success('Амжилттай шинэчлэгдлээ', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      } else {
        toast.error(message, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        fullWidth
        sx={{ justifyContent: 'start' }}
        startIcon={<Iconify icon="eva:checkmark-fill" />}
        onClick={handleClickOpen}
      >
        Засах
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Харьяа Хэлтэс засах</DialogTitle>
        <DialogContent
          sx={{
            py: 1,
          }}
        >
          <TextField
            sx={{
              my: 2,
            }}
            value={name}
            onChange={(event) => setName(event.target.value)}
            label="Гарчиг"
            type="text"
            fullWidth
            autoFocus
          />
          <TextField
            sx={{
              my: 2,
            }}
            value={order}
            onChange={(event) => setOrder(event.target.value)}
            label="Дараалал"
            type="text"
            fullWidth
          />
          {divisionUsers.length > 0 ? (
            <Autocomplete
              disablePortal
              id="users-box"
              isOptionEqualToValue={(option, value) => option.a_id === value.a_id}
              getOptionLabel={(option) => option.a_username}
              options={divisionUsers || []}
              sx={{ width: 1, my: 2 }}
              onChange={(_event, value) => setSelectedUser(value)}
              renderInput={(params) => <TextField {...params} label="Хэрэглэгч сонгох" />}
            />
          ) : (
            <>Харьяа хэлтэсгүй хэрэглэгч олдсонгүй</>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Цуцлах</Button>
          {loading ? 'loading' : <Button onClick={handleSubmit}>Хадгалах</Button>}
        </DialogActions>
      </Dialog>
    </>
  );
}
